// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer-module--SideDrawer--16CTt","Open":"SideDrawer-module--Open--2cas5","Close":"SideDrawer-module--Close--1CJVF","Logo":"SideDrawer-module--Logo--2DYYP"};